module.exports = __webpack_public_path__ + "img/filter.1897b06a.svg";